import { html } from 'lit';
import componentStyles from './print-button.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class PrintButton extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.styleclass = 'default';
  }

  onClick() {
    window.print()
  }

  render() {
    return html`
      <button @click="${this.onClick}" class="print-button print-button--${this.styleclass}">
        Print
        <hf-icon name="print" class="print-button__icon"></hf-icon>
      </button>`;
  }
}

customElements.define('hf-print-button', PrintButton);
